module.exports = __webpack_public_path__ + "img/warning.018fe76d.svg";